
import 'bootstrap/dist/css/bootstrap.min.css';
import '@aws-amplify/ui-react/styles.css';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/home-page';
import ExercisesPage from './pages/exercieses-page';
import { Authenticator } from '@aws-amplify/ui-react';
import { useState } from 'react';
import 'material-symbols';
import { CatalogPage } from './pages/catalog-page';
import { CatalogGroupPage } from './pages/catalog-group-page';
import { NotFound } from './pages/not-found';
import { UserProfilePage } from './pages/user-profile-page';
import { Tutorial } from './pages/tutorial';
import { PrivacyPolicy } from './pages/privacy-policy';
import { TermsAndConditions } from './pages/terms-and-conditions';
import { BuddiesPage } from './pages/buddies-page';
import { PublicHome } from './pages/public-home';
import { AuthLayout } from './auth-layout';
import { PublicLayout } from './pages/public-layout';

function App() {


  const [searchText, setSearchText] = useState("")
  const [language, setLanguage] = useState("en")

  return (
    <div className="App">
      <Authenticator.Provider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path='' element={<PublicHome />} />
              <Route path='privacy-policy' element={<PrivacyPolicy />} />
              <Route path='tutorial' element={<Tutorial />} />
            </Route>
            <Route element={<AuthLayout
              searchText={searchText}
              onSearchTextChanged={(e) => setSearchText(e)}
              language={language}
              onLanguageChanged={(e) => { setLanguage(e) }} />}>

              <Route path="dashboard" element={<HomePage />} />
              <Route
                path="exercises"
                element={<ExercisesPage
                  searchText={searchText} language={language} />} />
              <Route path="exercises/:id" element={<ExercisesPage
                searchText={searchText} language={language} />} />
              <Route path="exercises/:id/edit" element={<ExercisesPage
                searchText={searchText} exerciseEditor={true} createNewForm={false} language={language} />} />
              <Route path="exercises/new" element={<ExercisesPage
                searchText={searchText} exerciseEditor={true} createNewForm={true} language={language}></ExercisesPage>} />
              <Route path="catalog" element={<CatalogPage language={language} />} />
              <Route path="catalog/:group" element={<CatalogGroupPage searchText={searchText} language={language} />} />
              <Route path="posts/:id" element={<HomePage />} />
              <Route path='user-profile' element={<UserProfilePage ></UserProfilePage>} />
              <Route path='terms-and-conditions' element={<TermsAndConditions />} />
              <Route path='buddies' element={<BuddiesPage
                searchText={searchText}
                onError={() => {
                }} />} />
            </Route>
            <Route path='*' element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </Authenticator.Provider>
    </div >
  );


}

export default App;
